import Home from '../screens/Home';

const route = [
  {
    path: '/',
    main: Home,
    exact: true,
  },
];

export default route;
